import type * as React from 'react'

import { Slot } from '@buffer-mono/popcorn'

import { useCta } from '~publish/hooks/useCta'
import type { CtaProperties } from '~publish/hooks/useCta'

import type { JSX } from 'react'

type CtaButtonWrapperProps = {
  cta: CTA
  options?: CtaProperties
  children: React.ReactNode
}

/**
 * Use this component to easily track CTA views and clicks.
 *
 * @example
 * ```tsx
 * <CtaButtonWrapper cta="publish-allChannels-betaOptIn-joinBeta-1">
 *  <Button>Open</Button>
 * </CtaButtonWrapper>
 * ````
 *
 * @example
 * ```tsx
 * <CtaButtonWrapper cta="publish-allChannels-header-upgrade-1" options={{
 *  upgradePathName: 'allChannels-upgrade',
 * }}>
 *  <Button>Open</Button>
 * </CtaButtonWrapper>
 * ````
 */
export const CtaButtonWrapper = ({
  cta,
  options,
  children,
}: CtaButtonWrapperProps): JSX.Element => {
  const { clicked: ctaClicked } = useCta(cta, options)

  return <Slot.Root onClick={ctaClicked}>{children}</Slot.Root>
}
